// 统一暴露工具，供其他地方调用
import Vue from 'vue'
import Compressor from 'compressorjs'
let that = new Vue()
import authorized from './authorized'
import sc from './sc'
import map from './map'
import cubeUtils from './cube-utils'
import compress from './compress'
// 数组转对象
function arrToObj(arr) {
  // 参数必须是一个数组
  if (!Array.isArray(arr)) {
    throw new Error('type err: arr 必须是一个数组')
  }
  // 存放返回结果
  const obj = {}
  arr.map((item) => {
    obj[Object.keys(item)[0]] = item[Object.keys(item)[0]]
  })
  return obj
}
/**
 * @param image 图片
 * @param backType 需要返回的类型blob,file
 * @param quality 图片压缩比 0-1,数字越小，图片压缩越小
 * @returns
 */
const compressorImage = (image, backType, quality) => {
  return new Promise((resolve, reject) => {
    new Compressor(image, {
      quality: quality || 0.2,
      success(result) {
        let file = new File([result], image.name, { type: image.type })
        if (!backType || backType == 'blob') {
          resolve(result)
        } else if (backType == 'file') {
          resolve(file)
        } else {
          resolve(file)
        }
      },
      error(err) {
        console.log('图片压缩失败---->>>>>', err)
        reject(err)
      }
    })
  })
}
/**
 * 判断日期是否有效
 * @param {string} date 日期：2019-12-12
 * @returns {boolean}
 */
const isValidDate = (date) => {
  if (!date || date.indexOf('-') < 0) {
    return false
  }
  const dateArr = date.split('-')
  const year = dateArr[0] - 0
  const month = dateArr[1] - 0
  const day = dateArr[2] - 0
  const dateObj = new Date(year, month - 1, day)
  if (
    year === dateObj.getFullYear() &&
    month === dateObj.getMonth() + 1 &&
    day === dateObj.getDate()
  ) {
    // 全部相等，被校验日期合法
    return true
  }
  return false
}

/**
 * 校验手机号码是否有效
 * @param {string} mobile 手机号码
 * @returns {boolean}
 */
const checkMobile = (mobile) => {
  const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
  return reg.test(mobile)
}

/**
 * 校验身份证号15、18位
 * 18位规则
 *1、将前面的身份证号码17位数分别乘以不同的系数。从第一位到第十七位的系数分别为：7－9－10－5－8－4－2－1－6－3－7－9－10－5－8－4－2
 *2、将这17位数字和系数相乘的结果相加。
 *3、用加出来和除以11，看余数是多少？
 *4、余数只可能有0－1－2－3－4－5－6－7－8－9－10这11个数字。其分别对应的最后一位身份证的号码为1－0－X －9－8－7－6－5－4－3－2
 * @param {string} idcard 身份证号码
 */
const checkIdcard = (idcard) => {
  let ereg
  let Y, JYM
  let S, M
  let idcardArray = []
  idcardArray = idcard.toUpperCase().split('')
  console.log(`----居民身份证${idcard}`)
  switch (idcard.length) {
    case 15:
      if (
        (parseInt(idcard.substr(6, 2), 10) + 1900) % 4 === 0 ||
        ((parseInt(idcard.substr(6, 2), 10) + 1900) % 100 === 0 &&
          (parseInt(idcard.substr(6, 2), 10) + 1900) % 4 === 0)
      ) {
        ereg =
          /^[1-6][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-6]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}$/ // 测试出生日期的合法性
      } else {
        ereg =
          /^[1-6][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-6]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}$/ // 测试出生日期的合法性
      }
      if (!ereg.test(idcard)) {
        return false
      }
      break
    case 18:
      if (
        parseInt(idcard.substr(6, 4), 10) % 4 === 0 ||
        (parseInt(idcard.substr(6, 4), 10) % 100 === 0 &&
          parseInt(idcard.substr(6, 4), 10) % 4 === 0)
      ) {
        ereg =
          /^[1-6][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}[0-9Xx]$/ // 闰年出生日期的合法性正则表达式
      } else {
        ereg =
          /^[1-6][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}[0-9Xx]$/ // 平年出生日期的合法性正则表达式
      }
      if (ereg.test(idcard)) {
        // 测试出生日期的合法性
        // 计算校验位
        S =
          (parseInt(idcardArray[0], 10) + parseInt(idcardArray[10], 10)) * 7 +
          (parseInt(idcardArray[1], 10) + parseInt(idcardArray[11], 10)) * 9 +
          (parseInt(idcardArray[2], 10) + parseInt(idcardArray[12], 10)) * 10 +
          (parseInt(idcardArray[3], 10) + parseInt(idcardArray[13], 10)) * 5 +
          (parseInt(idcardArray[4], 10) + parseInt(idcardArray[14], 10)) * 8 +
          (parseInt(idcardArray[5], 10) + parseInt(idcardArray[15], 10)) * 4 +
          (parseInt(idcardArray[6], 10) + parseInt(idcardArray[16], 10)) * 2 +
          parseInt(idcardArray[7], 10) * 1 +
          parseInt(idcardArray[8], 10) * 6 +
          parseInt(idcardArray[9], 10) * 3
        Y = S % 11
        M = 'F'
        JYM = '10X98765432'
        M = JYM.substr(Y, 1) // 判断校验位
        if (M !== idcardArray[17]) {
          // 检测ID的校验位
          return false
        }
      } else {
        return false
      }
      break
    case 0:
      break
    default:
      console.log(`居民身份证${idcard}`)
      if (idcard.length > 0) {
        return false
      }
      break
  }
  return true
}
// 邮箱校验
const checkMail = (email) => {
  let reg = /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/ //正则表达式
  return reg.test(email)
}
// 根据身份证计算出生日期
const getBirthdayFromIdCard = (idCard) => {
  let birthday = ''
  if (idCard != null && idCard != '') {
    if (idCard.length == 15) {
      birthday = `19${idCard.substr(6, 6)}`
    } else if (idCard.length == 18) {
      birthday = idCard.substr(6, 8)
    }
    birthday = birthday.replace(/(.{4})(.{2})/, '$1-$2-')
  }
  return birthday
}
// 根据身份证获取性别
const getSexFromIdCard = (idCard) => {
  let sexValue = ''
  if (idCard != null && idCard != '') {
    if (idCard.length == 15) {
      sexValue = parseInt(idCard.substr(14, 1)) % 2 == 1 ? '男' : '女'
    } else if (idCard.length == 18) {
      sexValue = parseInt(idCard.substr(16, 1)) % 2 == 1 ? '男' : '女'
    }
  }
  return sexValue
}
/** 校验表单必填
 *
 * @param {Object} obj 需要被校验的表单
 * @param {Array} requiredPropList // 必填属性及提示话术 { prop: '属性', text: '提示语'}
 * @return {Boolean} 校验结果， true通过校验， false未通过
 */
const checkFormRequired = (obj, requiredPropList) => {
  let flag = true
  for (let i = 0; i < requiredPropList.length; i++) {
    if (!obj[requiredPropList[i].prop]) {
      flag = false
      that.$msg(requiredPropList[i].text)
      break
    }
  }
  return flag
}
/**
 *将码表的code转化成value
 * 转化关系码表
 * @param {array} typeList 码表
 * @param {string} value 需要转化的码值
 * @returns {string}
 */
const codeToValue = (typeList, value) => {
  console.log(typeList, value)
  /* eslint-disable */
  for (let i = 0; i < typeList.length; i++) {
    if (typeList[i].code == value) {
      return typeList[i].value
    }
  }
  return value
}

// 设置cookie
const setCookie = (name, vaue) => {
  document.cookie = name + '=' + escape(value)
}
//获取指定名称的cookie的值
const getCookie = (objname) => {
  const arrstr = document.cookie.split('; ')
  for (let i = 0; i < arrstr.length; i++) {
    const temp = arrstr[i].split('=')
    if (temp[0] == objname) return unescape(temp[1])
  }
}
// 获取星期几中文
const getWeekday = (date) => {
  if (!date) {
    return ''
  }
  const val = new Date(date).getDay()
  const weekday = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
  return weekday[val]
}
// 获取星期几英文
const getWeekdayEn = (date) => {
  if (!date) {
    return ''
  }
  const val = new Date(date).getDay()
  const weekday = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ]
  return weekday[val]
}
// 比较日期大小
const compareDate = (d1, d2) => {
  if (d1 && d2) {
    const arrayD1 = d1.split('-')
    const date1 = new Date(arrayD1[0], arrayD1[1], arrayD1[2])
    const arrayD2 = d2.split('-')
    const date2 = new Date(arrayD2[0], arrayD2[1], arrayD2[2])
    if (date1 > date2) return false
    return true
  } else {
    return false
  }
}
// 行内样式转rem
const px2rem = (px) => {
  if (/%/gi.test(px)) {
    return px
  } else {
    return parseFloat(px) / 37.5 + 'rem'
  }
}
// 判断的是否是JSON字符串
export const typeJson = (str) => {
  if (typeof str == 'string') {
    try {
      const obj = JSON.parse(str)
      // 等于这个条件说明就是JSON字符串 会返回true
      if (typeof obj == 'object' && obj) {
        return true
      }
      //不是就返回false
      return false
    } catch (e) {
      return false
    }
  }
  return false
}
export default {
  ...sc,
  ...authorized,
  ...map,
  ...cubeUtils,
  ...compress,
  compressorImage,
  arrToObj,
  isValidDate,
  checkMobile,
  checkIdcard,
  checkMail,
  getBirthdayFromIdCard,
  getSexFromIdCard,
  checkFormRequired,
  codeToValue,
  setCookie,
  getCookie,
  getWeekday,
  getWeekdayEn,
  compareDate,
  px2rem,
  typeJson
}
